import { render, staticRenderFns } from "./CustasExcluidas.vue?vue&type=template&id=5af86b3a&"
import script from "./CustasExcluidas.vue?vue&type=script&lang=js&"
export * from "./CustasExcluidas.vue?vue&type=script&lang=js&"
import style0 from "./CustasExcluidas.vue?vue&type=style&index=0&id=5af86b3a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports